var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42516 17.2253C7.26683 17.2253 7.1085 17.1669 6.9835 17.0419C6.74183 16.8003 6.74183 16.4003 6.9835 16.1586L12.4168 10.7253C12.8168 10.3253 12.8168 9.67526 12.4168 9.27526L6.9835 3.84193C6.74183 3.60026 6.74183 3.20026 6.9835 2.95859C7.22516 2.71693 7.62516 2.71693 7.86683 2.95859L13.3002 8.39193C13.7252 8.81693 13.9668 9.39193 13.9668 10.0003C13.9668 10.6086 13.7335 11.1836 13.3002 11.6086L7.86683 17.0419C7.74183 17.1586 7.5835 17.2253 7.42516 17.2253Z",
    fill: "#3A4251"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.df5bb5ff86c5e6a1a6f1475f310e2b18.svg";
export { ForwardRef as ReactComponent };